import { basename } from '../../utils';

export const fetchSettings = async (setSettings) => {
    try{

        let result = await fetch(`/${basename}/services/milieuzones/get_settings`, { ///${basename}/services/eloket/check_lp
            method: 'GET',
        })

        if (result.ok === true){
            let json = await result.json()
            let data = json && json.result ? json.result : json
            data = data && data.length > 0 ? data[0] : data
            setSettings(data)
        }else{

        }
    }catch(e){
        console.log('catch error', e)
        alert('loading settings error')
    }
}
